<template>
  <v-app>
    <v-app-bar color="blue darken-3" dark app v-if="showDesktopChrome">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>{{ $t('app_bar_title') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-row>
        <v-col></v-col>
        <v-col></v-col>
        <v-col cols="6" sm="6" md="6" lg="6" xl="3">
          <v-text-field
            class="mt-7"
            solo
            light
            :label="$t('app_bar_search')"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-menu bottom min-width="100px" rounded offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn class="white--text ma-5" v-bind="attrs" v-on="on" icon>
            <v-icon>mdi-flag</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item-group v-model="selectionItem" mandatory color="indigo">
            <v-list-item
              v-for="localeItem in localeItems"
              :key="localeItem.value"
              link
              @click="ChangeLocale(localeItem.value)"
            >
              <v-list-item-title>{{ localeItem.text }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-menu bottom min-width="200px" rounded offset-y>
        <template v-slot:activator="{ on }">
          <v-btn small v-on="on" class="ml-2" fab color="grey">
            <v-avatar color="grey" size="48" class="ml-3">
              <span class="white--text text-h5">{{ initials }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <v-avatar color="grey">
                <span class="white--text text-h5">{{ initials }}</span>
              </v-avatar>
              <h3 class="mt-3">{{ getUserAccountId }}</h3>
              <p class="text-caption mt-1">
                {{ email }}
              </p>
              <v-divider class="my-2"></v-divider>

              <v-dialog v-model="isShowPersonalDialog" max-width="500px" persistent>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" text @click="isShowPersonalDialogBtn">
                    {{ $t('app_bar_personal_btn') }}
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <!-- <span class="text-h5">{{ userDialogTitle }}</span> -->
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                          <v-text-field
                            v-model="editedUser.UserName"
                            :label="$t('user_username')"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                          <v-text-field v-model="editedUser.NickName" label="中文名稱"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                          <v-text-field v-model="editedUser.Email" :label="$t('user_email')"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                          <v-checkbox
                            v-model="checkUpdatePassword"
                            :label="$t('user_update_password')"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                          <ValidationProvider
                            :name="$t('user_pass')"
                            :rules="{ required: true, min: 6 }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              autocomplete="current-password"
                              :append-icon="!value ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="value = !value"
                              :type="value ? 'password' : 'text'"
                              v-model="editedUser.Password"
                              :label="$t('user_pass')"
                              v-if="checkUpdatePassword"
                              :error-messages="errors[0]"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeEditedUser"
                      :disabled="isAllTextFieldDisable"
                    >
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="saveEditedUser" :loading="isLoadingSaveBtn">
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-divider class="my-2"></v-divider>
              <v-btn @click="logoutClickEvent" text>
                {{ $t('app_bar_logout_btn') }}
              </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" width="350" app v-if="showDesktopChrome">
      <div class="py-5"></div>
      <v-spacer></v-spacer>
      <div class="mx-15" align="right"></div>
      <v-list class="mx-6 mt-5">
        <v-list-group
          v-for="item in visibleItems"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`${item.title}`) }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="child in item.visibleChildren" :key="child.title" :to="child.link" link>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t(`${child.title}`) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-main v-if="showAuthenticatedMain">
      <router-view :class="{ 'ma-5': showDesktopChrome }" />
    </v-main>

    <router-view name="login"></router-view>

    <v-snackbar v-model="permissionLoadFailedSnackbar" :timeout="-1" color="error" top right>
      {{ $t('permission_load_failed') }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="$router.go(0)">
          {{ $t('permission_load_failed_retry') }}
        </v-btn>
        <v-btn icon v-bind="attrs" @click="permissionLoadFailedSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="accessDeniedSnackbar" :timeout="5000" color="warning" top right>
      {{ accessDeniedText }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="accessDeniedSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import i18n from '@/i18n'
import { localize } from 'vee-validate'
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import { HttpUser } from '@/js/http-Manager'
import { MENU_RESOURCE_KEYS, validateSidebarRegistration } from '@/js/permission-catalog'
import {
  isAuthenticatedRouteVisible,
  isDesktopChromeVisible,
  waitForInitialNavigation
} from '@/js/auth-redirect'
export default {
  name: 'App',

  data: () => ({
    drawer: false,
    group: null,
    editedUser: {
      UserName: '',
      Password: '',
      Email: '',
      NickName: ''
    },

    items: [
      {
        icon: 'mdi-file',
        active: false,
        moduleKey: MENU_RESOURCE_KEYS.BASIC,
        items: [
          { title: 'app_basic_item', link: '/item', requires: { resource: 'item', action: 'view' } },
          {
            title: 'app_basic_item_group',
            link: '/item_group',
            requires: { resource: 'item_group', action: 'view' }
          },
          {
            title: 'app_basic_install_position',
            link: '/install_position',
            requires: { resource: 'install_position', action: 'view' }
          },
          {
            title: 'app_basic_consumer',
            link: '/customer',
            requires: { resource: 'customer', action: 'view' }
          },
          {
            title: 'app_basic_product_id',
            link: '/serial_number',
            requires: { resource: 'serial_number', action: 'view' }
          },
          {
            title: 'app_basic_init_resume',
            link: '/init_resume',
            requires: { resource: 'init_resume', action: 'view' }
          },
          {
            title: 'app_month_init_month',
            link: '/new_init_month',
            requires: { resource: 'new_init_month', action: 'view' }
          },
          { title: 'app_basic_point', link: '/point', requires: { resource: 'point', action: 'view' } },
          { title: 'app_basic_bom', link: '/bom', requires: { resource: 'bom', action: 'view' } },
          {
            title: 'app_basic_month_bom',
            link: '/month_bom',
            requires: { resource: 'month_bom', action: 'view' }
          },
          { title: 'user_tool_bar_title', link: '/user', requires: { resource: 'user', action: 'view' } },
          {
            title: 'engineer_stock_title',
            link: '/engineer_stock',
            requires: { resource: 'engineer_stock', action: 'view' }
          },
          {
            title: 'tp_manager_title',
            link: '/tp_manager',
            requires: { resource: 'tp_manager', action: 'view' }
          },
          {
            title: 'special_need_title',
            link: '/special_need',
            requires: { resource: 'special_need', action: 'view' }
          },
          {
            title: 'check_excel_title',
            link: '/check_excel',
            requires: { resource: 'check_excel', action: 'view' }
          },
          {
            title: 'page_change_record_title',
            link: '/page_change_record',
            requires: { resource: 'page_change_record', action: 'view' }
          },
          {
            title: 'customer_license_plate_mapping_title',
            link: '/customer_license_plate_mapping',
            requires: { resource: 'customer_license_plate_mapping', action: 'view' }
          },
          {
            title: 'temp_stock_title',
            link: '/temp_stock',
            requires: { resource: 'temp_stock', action: 'view' }
          },
          {
            title: 'throw_sunlike_sale_title',
            link: '/throw_sunlike_sale',
            requires: { resource: 'throw_sunlike_sale', action: 'view' }
          }
        ],
        title: 'app_basic_information'
      },
      {
        icon: 'mdi-sale',
        active: false,
        moduleKey: MENU_RESOURCE_KEYS.SALES,
        items: [
          {
            title: 'app_sales_quotation',
            link: '/quotation',
            requires: { resource: 'quotation', action: 'view' }
          },
          {
            title: 'transfer_order_title',
            link: '/transfer_order',
            requires: { resource: 'transfer_order', action: 'view' }
          },
          {
            title: 'app_sales_contract',
            link: '/customer_repair',
            requires: { resource: 'customer_repair', action: 'view' }
          },
          // update_customer_repair 未 seed 至 catalog，不可加 requires（fail-closed 會永遠隱藏）
          { title: 'app_sales_update_contract', link: '/update_customer_repair' }
        ],
        title: 'app_sales_module'
      },
      {
        icon: 'mdi-clipboard-outline',
        active: false,
        moduleKey: MENU_RESOURCE_KEYS.INSTALL,
        items: [
          { title: 'app_install_notice', link: '/notice', requires: { resource: 'notice', action: 'view' } },
          {
            title: 'app_install_acceptance',
            link: '/acceptance',
            requires: { resource: 'acceptance', action: 'view' }
          },
          { title: 'app_repair_fix', link: '/fix', requires: { resource: 'fix', action: 'view' } },
          { title: 'app_repair_repair', link: '/repair', requires: { resource: 'repair', action: 'view' } },
          { title: 'app_repair_resume', link: '/resume', requires: { resource: 'resume', action: 'view' } },
          {
            title: 'app_engineer_work',
            link: '/engineer_work',
            requires: { resource: 'engineer_work', action: 'view' }
          },
          {
            title: 'app_authorize_mapping',
            link: '/authorize_mapping',
            requires: { resource: 'authorize_mapping', action: 'view' }
          }
        ],
        title: 'app_install_module'
      },
      {
        icon: 'mdi-calendar-blank',
        active: false,
        moduleKey: MENU_RESOURCE_KEYS.MONTH,
        items: [
          {
            title: 'app_month_quotation',
            link: '/month_quotation',
            requires: { resource: 'month_quotation', action: 'view' }
          },
          {
            title: 'app_month_month',
            link: '/new_month',
            requires: { resource: 'new_month', action: 'view' }
          },
          { title: 'app_month_settle', link: '/settle', requires: { resource: 'settle', action: 'view' } },
          {
            title: 'app_month_discount',
            link: '/new_discount',
            requires: { resource: 'new_discount', action: 'view' }
          },
          {
            title: 'check_month_excel_pay_title',
            link: '/check_month_excel_pay',
            requires: { resource: 'check_month_excel_pay', action: 'view' }
          },
          { title: 'overage_title', link: '/overage', requires: { resource: 'overage', action: 'view' } }
        ],
        title: 'app_month_module'
      },
      {
        icon: 'mdi-shield-account-outline',
        active: false,
        // moduleKey = 對應「選單層」resource；沒 view 權限則整個 group 隱藏
        moduleKey: MENU_RESOURCE_KEYS.PERMISSION,
        items: [
          {
            title: 'permission_users_title',
            link: '/permission/users',
            requires: { resource: 'permission_users', action: 'view' }
          },
          {
            title: 'permission_roles_title',
            link: '/permission/roles',
            requires: { resource: 'permission_roles', action: 'view' }
          },
          {
            title: 'permission_resources_title',
            link: '/permission/resources',
            requires: { resource: 'permission_resources', action: 'view' }
          }
        ],
        title: 'app_permission_module'
      }
    ],

    initials: 'JC',
    fullName: 'Judy Chen',
    email: 'judy.chen@egk.com.tw',
    locale: 'tw',
    localeItems: [
      { text: '繁體中文', value: 'tw' },
      { text: 'English', value: 'en' }
    ],
    selectionItem: 0,
    // a: '',
    isShowPersonalDialog: false,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    editedUserIndex: -1,
    checkUpdatePassword: false,
    userList: [],
    value: false,
    permissionLoadFailedSnackbar: false,
    accessDeniedSnackbar: false,
    accessDeniedText: ''
  }),
  methods: {
    // 呼叫login.js的方式在這裡
    ...mapMutations('login', {
      // 需要具名化，他來自哪裡  store/index.js裡面的modules
      setJwt: 'setJwt' // mutations裡面的function  setJwt
    }),
    ...mapActions('login', ['logout']), // mapActions裡面的function logout
    logoutClickEvent () {
      this.logout() // 呼叫login.js裡的function 一樣使用一般呼叫方式 logout()即可
      this.$router.push('/login', () => {}) // 跳轉回login頁面
    },
    isShowPersonalDialogBtn () {
      this.value = true
      this.checkUpdatePassword = false
      this.isShowPersonalDialog = true
    },
    async getUser () {
      let response = await HttpUser.GetUsers()
      this.isLoadingUser = false
      const list = (response && response.status === 200 && response.data && response.data.Data) || []
      this.userList = Array.isArray(list) ? list : []
      this.userList.forEach((element, index) => {
        if (element && element.UserName === this.getUserAccountId) {
          this.editedUserIndex = index
          this.editedUser = Object.assign({}, element)
          this.email = element.Email
        }
      })
    },
    closeEditedUser () {
      this.isShowPersonalDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.editedUser.Password = ''
    },

    async saveEditedUser () {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisable = true
      await HttpUser.UpdatePersonalDetail(this.editedUser)
      this.closeEditedUser()
      this.getUser()
      this.$router.go(this.$route.path)
    },
    syncPermissionLoadSnackbar (value = this.permissionLoadError) {
      const route = this.$route || {}
      const isPermissionRoute =
        (route.path && route.path.startsWith('/permission')) || (route.meta && route.meta.requiresPermission)
      this.permissionLoadFailedSnackbar = !!value && !!isPermissionRoute
    },
    ChangeLocale (value) {
      if (value === 'tw') {
        this.selectionItem = 0
      } else {
        this.selectionItem = 1
      }
      this.locale = value
      i18n.locale = this.locale
      document.title = this.getRouterName
      localize(this.locale)
      let clearTime = new Date()
      clearTime.setFullYear(clearTime.getFullYear() + 1)
      document.cookie = `locale=${this.locale};expires=${clearTime.toGMTString()};path=/`
    }
  },
  created () {
    const Jwt = window.localStorage.getItem('Jwt') // 取得localStorage Jwt登入憑證
    if (Jwt) {
      this.setJwt(Jwt)
      this.initials = this.getUserAccountId.slice(0, 2).toUpperCase()
    }
    if (process.env.NODE_ENV !== 'production') {
      const missingSidebar = validateSidebarRegistration(this.items)
      if (missingSidebar.length) {
        console.warn('[權限註冊] 以下 sidebar 項目缺 requires 且非顯式 public：', missingSidebar)
      }
    }
  },
  watch: {
    Jwt (value) {
      if (value === '') {
        this.logoutClickEvent()
      }
    },
    permissionLoadError (val) {
      this.syncPermissionLoadSnackbar(val)
    },
    permissionAccessDenied (val) {
      if (!val) return
      this.accessDeniedText = this.$t('permission_access_denied', {
        resource: val.resource,
        action: val.action
      })
      this.accessDeniedSnackbar = true
      // 消費後清回 null，讓下次同一 resource 再被擋仍能重新觸發 watcher
      this.$store.commit('permission/setAccessDenied', null)
    },
    $route () {
      this.syncPermissionLoadSnackbar()
      document.title = this.getRouterName
    }
  },
  async mounted () {
    await waitForInitialNavigation(this.$router)
    if (this.isLogin && this.showDesktopChrome) {
      await this.getUser()
    }

    let self = this

    let cookieData = document.cookie.match(new RegExp('(^| )locale=([^;]*)(;|$)'))

    // 白名單：cookie value 必須是已註冊的 vee-validate locale，否則 fallback（未註冊 locale 會讓 vee-validate 拋錯）
    const SUPPORTED_LOCALES = ['tw', 'en']
    if (cookieData && cookieData[2] && SUPPORTED_LOCALES.includes(cookieData[2])) {
      self.locale = cookieData[2]
    }
    if (!SUPPORTED_LOCALES.includes(self.locale)) {
      self.locale = 'tw'
    }
    if (self.locale === 'tw') {
      self.selectionItem = 0
    } else {
      self.selectionItem = 1
    }
    i18n.locale = self.locale
    document.title = self.getRouterName
    localize(self.locale)
  },
  computed: {
    ...mapGetters('login', {
      // getters裡面的function isLogin
      isLogin: 'isLogin',
      getUserAccountId: 'getUserAccountId',
      parseJwt: 'parseJwt'
    }),
    ...mapGetters('permission', {
      can: 'can'
    }),
    ...mapState('permission', {
      permissionLoadError: 'loadError',
      permissionAccessDenied: 'accessDenied'
    }),
    getRouterName () {
      return this.$t(this.$route.meta.title)
    },
    showDesktopChrome () {
      return isDesktopChromeVisible(this.isLogin, this.$route)
    },
    showAuthenticatedMain () {
      return isAuthenticatedRouteVisible(this.isLogin, this.$route)
    },
    // 依權限決定哪些 sidebar group / child 要顯示。
    //
    // 三段式過濾：
    //   1. group.moduleKey 有設 → 必須有 moduleKey:view 才顯示整個 group（對應 menu 層）
    //   2. child.requires 有設 → 必須有 requires.resource:requires.action 才顯示該 child（對應 page 層）
    //   3. 未設（大多數舊業務頁面）→ 沿用 default-allow，直接顯示
    //
    // 最後的 visibleChildren.length > 0 過濾刻意保留：
    //   - 如果 group 下所有子頁面都被擋（即使 menu 有 view），展開也只是空清單，不如整個 group 收掉，UI 更乾淨。
    //   - 若之後需要顯示「空 group + 提示訊息」，再解除這個 filter 並在 template 處理即可。
    //
    // permission store 的 can getter 是 fail-closed：未載入或 entry 缺失時回 false。
    // 由 router beforeEach 在登入後首次導航時主動 dispatch('permission/load')，
    // 確保 sidebar 拿到 effective permissions 後才正確顯示權限選單，避免 race。
    visibleItems () {
      return this.items
        .filter((item) => !item.moduleKey || this.can(item.moduleKey, 'view'))
        .map((item) => ({
          ...item,
          visibleChildren: (item.items || []).filter(
            (child) => !child.requires || this.can(child.requires.resource, child.requires.action)
          )
        }))
        .filter((item) => item.visibleChildren.length > 0)
    }
  }
}
</script>
